import { useCallback } from 'react';
import { toast } from 'sonner';
import { AI_PREFILL_PROMPT, type AiProvider } from './aiProviders';

export function useDocActions(markdown: string) {
  const openInAI = useCallback(
    async (provider: AiProvider) => {
      const url = provider.getUrl(encodeURIComponent(AI_PREFILL_PROMPT));
      try {
        await navigator.clipboard.writeText(markdown);
      } catch {
        toast.error('Не удалось скопировать инструкцию в буфер обмена');
        return;
      }
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    [markdown],
  );

  return { openInAI };
}
